<template>
  <div class="container w-full flex flex-col justify-between gap-30 xl:gap-50 py-50 border-b border-light-gray-3">
    <div class="w-full">
      <h2 class="mb-20 font-bold text-lg">Online Payments</h2>
      <div
        class="grid gap-12 grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
      >
        <div
          v-for="item in onlinePayments"
          :key="item.name"
          class="flex justify-center"
        >
          <img
            :src="'/assets/images/payments/' + item.img + '.png'"
            :alt="item.name"
            :title="item.name"
          />
        </div>
      </div>
    </div>
    <div class="w-full">
      <h2 class="mb-20 font-bold text-lg">
        Installments
      </h2>
      <div
        class="grid gap-12 grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
      >
        <div
          v-for="item in installmentPayments"
          :key="item.name"
          class="flex justify-center"
        >
          <img
            :src="'/assets/images/payments/' + item.img + '.png'"
            :alt="item.name"
            :title="item.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFooterPaymentMethods",
  data() {
    return {
      onlinePayments: [
        { name: "Visa", img: "visa" },
        { name: "Mastercard", img: "mastercard" },
        { name: "JCB", img: "jcb" },
        { name: "Paymaya", img: "maya" },
        { name: "GCash", img: "gcash" },
        { name: "RCBC Bankard", img: "rcbc" },
        { name: "UnionBank", img: "unionbank" },
        { name: "BDO", img: "bdo" },
        { name: "PNB", img: "pnb" },
        { name: "BancNet", img: "bancnet" },
        { name: "BPI Direct Banko", img: "bpi-banko" },
        { name: "CTBC Bank", img: "ctbc" },
        { name: "Citystate Savings Bank", img: "citystate" },
        { name: "Enterprise Bank", img: "enterprise" },
        { name: "Equicom Savings Bank", img: "equicom" },
        { name: "MASS-SPECC", img: "mass-specc" },
        { name: "PBCOM", img: "pbcom" },
        { name: "Pacific Ace Savings Bank", img: "pacific-ace" },
        { name: "Phil Postal Savings Bank", img: "postbank" },
        { name: "Philippine Veterans Bank", img: "veteransbank" },
        { name: "Philtrust Bank", img: "phil-trust" },
        { name: "Sterling Bank of Asia", img: "sterling" },
        { name: "Sun Savings Bank", img: "sun-savings" },
        { name: "Tiaong Rural Bank", img: "trbi" },
        { name: "DBP", img: "dbp" },
        { name: "Entrepreneur Bank", img: "entreprenuer" },
        { name: "BPI Express Online/Mobile", img: "bpi" },
      ],
      installmentPayments: [
        { name: "BPI Real 0%", img: "bpi-real" },
        { name: "BPI", img: "bpi" },
        { name: "HSBC", img: "hsbc" },
        { name: "UnionBank", img: "unionbank" },
      ],
    };
  },
};
</script>

<style scoped></style>
